import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { useCurrency } from "../context/CurrencyContext";

const WhatsAppIcon = () => (
  <svg className="wa-icon-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const settings = useSettings();
  const { currency, toggleCurrency } = useCurrency();
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img key="logo-img" src="/assets/branding/logo.png" alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '6px', objectFit: 'cover' }} />
        <span>{settings.site_name || "HandyCraft"}</span>
      </Link>

      <div className="nav-links">
        <Link to="/" className={`nav-link ${isActive("/") ? "active" : ""}`}>
          Beranda
        </Link>
        <Link to="/products" className={`nav-link ${isActive("/products") ? "active" : ""}`}>
          Koleksi Produk
        </Link>
        
        {user?.role === "admin" && (
          <Link to="/admin/dashboard" className={`nav-link ${isActive("/admin/dashboard") ? "active" : ""}`}>
            Dashboard Admin
          </Link>
        )}
      </div>

      <div className="nav-auth">
        <button 
          onClick={toggleCurrency} 
          className="btn-currency-switcher"
          title="Ganti Mata Uang"
        >
          <span className="icon-globe">🌐</span>
          <span>{currency === 'IDR' ? 'IDR' : 'USD'}</span>
          <span className="icon-arrow">⇅</span>
        </button>

        {!token ? (
           <a 
            href={`https://wa.me/${settings.whatsapp_number || '6282111307477'}`} 
            target="_blank" 
            rel="noreferrer"
            className="btn btn-primary"
            style={{ gap: '10px', display: 'flex', alignItems: 'center' }}
           >
             <WhatsAppIcon />
             <span>Tanya Kami</span>
           </a>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <span style={{ fontWeight: 600, color: 'var(--primary)' }}>Admin: {user.name}</span>
            <button className="btn btn-outline" onClick={logout} style={{ padding: '0.4rem 1.2rem' }}>
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
